import { PageSection, Partnership, Table, TableColumnHeader, TableRow } from '@/common'
import MissingResourcesAlert from '@/components/MissingResourcesAlert'
import { LoadingScreen } from '@/shared/components'
import useI18n from '@/shared/hooks/useI18n'
import RejectedImporterRow from './components/RejectedImporterRow'

export default function ImportersRejectedInvitations({
  rejectedPartnerships,
  isLoading
}: {
  rejectedPartnerships: Partnership[]
  isLoading: boolean
}) {
  const { t } = useI18n()

  const hasRejectedPartnerships = rejectedPartnerships.length > 0

  return (
    <PageSection title={t('importers:importerRejectionList.title')}>
      {isLoading && <LoadingScreen />}
      {!isLoading && !hasRejectedPartnerships && (
        <MissingResourcesAlert
          title={t('importers:importerRejectionList.noRejectedInvitations.title')}
          description={t('importers:importerRejectionList.noRejectedInvitations.description')}
        />
      )}
      {hasRejectedPartnerships && (
        <Table className="table-fixed">
          <thead>
            <TableRow>
              <TableColumnHeader className="w-72">
                {t('importers:importerRejectionList.table.importerName')}
              </TableColumnHeader>
              <TableColumnHeader className="w-48">
                {t('importers:importerRejectionList.table.dateOfRejection')}
              </TableColumnHeader>
              <TableColumnHeader className="w-48">
                {t('importers:importerRejectionList.table.reason')}
              </TableColumnHeader>
              <TableColumnHeader className="w-48">
                {t('importers:importerRejectionList.table.invitationType')}
              </TableColumnHeader>
            </TableRow>
          </thead>
          <tbody>
            {rejectedPartnerships.map(partnership => (
              <RejectedImporterRow key={partnership.id} partnership={partnership} />
            ))}
          </tbody>
        </Table>
      )}
    </PageSection>
  )
}
